'use strict';
module.exports = require('../../full/object/group-by');
